import { Container, TextStyle, Text, Sprite, Point } from "pixi.js";
import { CommonResourcesPackage } from "../../../common/resources/CommonResourcesPackage";
import { GameFont } from "../../../common/GameFont";
import { StringFormatExtention } from "../../../../../extensions/StringFormatExtention";
import { DropShadowFilter } from "pixi-filters";

export class PushRewardContainer extends Container {
    public constructor(rewardValue: number, commonResources: CommonResourcesPackage) {
        super();
        const firtsShadowFilter = new DropShadowFilter({ offset: new Point(0, 0), blur: 30, color: 0x37D7FF, quality: 4, alpha: 0.6 });
        const secondShadowFilter = new DropShadowFilter({ offset: new Point(0, 0), blur: 10, color: 0x00A3FF, quality: 4, alpha: 0.6 });
        const thirdShadowFilter = new DropShadowFilter({ offset: new Point(0, 0), blur: 5, color: 0xFFFFFF, quality: 4, alpha: 0.7 });

        const descriptionText = new Text('AND RECEIVE A', new DescriptionTextStyle());
        descriptionText.anchor.set(0.5);
        descriptionText.skew.set(0, -0.09);
        descriptionText.filters = [firtsShadowFilter, secondShadowFilter, thirdShadowFilter];
        this.addChild(descriptionText);

        const rewardCountText = new Text(StringFormatExtention.formatWithComma(rewardValue), new NumberTextStyle());
        rewardCountText.style.fontSize = 150;
        rewardCountText.anchor.set(0.5);
        rewardCountText.skew.set(0, -0.09);
        rewardCountText.position.set(-57, 135);
        rewardCountText.filters = [firtsShadowFilter, secondShadowFilter, thirdShadowFilter];
        this.addChild(rewardCountText);

        const coinIcon = new Sprite(commonResources.assets_common_ui_top_panel_coin_png);
        coinIcon.anchor.set(0.5);
        coinIcon.scale.set(1.35);
        coinIcon.position.set(rewardCountText.x + rewardCountText.width * 0.5 + coinIcon.width * 0.5, rewardCountText.y - coinIcon.height * 0.3);
        this.addChild(coinIcon);
    }
}

class DescriptionTextStyle extends TextStyle {
    public constructor() {
        super(new TextStyle({
            align: "center",
            fill: "#ffffff",
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 64,
            padding: 40
        }));
    }
}

class NumberTextStyle extends DescriptionTextStyle {
    public constructor() {
        super();
        this.fontSize = 90;
    }
}